import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


//This may be a module that can be retired and moved into the shared module.  I'm moving pieces at a time to make sure I don't break anything -CS

@NgModule({
    imports: [
        CommonModule,       
        FormsModule,
        NgbModule
    ],
    declarations: [],
    exports: [
        CommonModule,
        FormsModule,
        NgbModule
    ],
})
export class SharedFormsModule { }
